<template>
  <el-dialog title="发货方式" width="600px" :visible.sync="dialogVisible" @closed="handleClose">
    <div class="sub-title">
      发货方式支持修改为全款预售模式。<el-link target="_blank" href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/3dpqcP9FdvfX9Gsj">详情</el-link>
    </div>
    <el-form ref="form" :model="formData" :rules="formRules" inline>
      <el-row>
        <el-form-item label="库存情况" prop="stockType">
          <el-radio-group v-model="formData.stockType" @change="handleStockTypeChanged">
            <el-radio :label="0">现货</el-radio>
            <el-radio :label="1">全款预售</el-radio>
          </el-radio-group>
          <p class="tips-wrap">
            <template v-if="formData.stockType === 0">
              买家需要全款支付商品，商家需要在买家支付后3日内完成发货。
            </template>
            <template v-else>
              买家需要全款支付商品，商家需要在买家支付后规定时间内完成发货。
            </template>
          </p>
        </el-form-item>
      </el-row>
      <template v-if="formData.stockType === 1">
        <el-row>
          <el-form-item label="发货节点" prop="fullPaymentPresaleDeliveryType">
            <el-radio-group v-model="formData.fullPaymentPresaleDeliveryType" @change="handleDeliveryTypeChanged">
              <el-radio :label="0">买家付款后n天发货</el-radio>
              <el-radio :label="1">商家预售结束后n天发货</el-radio>
            </el-radio-group>
            <p class="tips-wrap">
              <template v-if="formData.fullPaymentPresaleDeliveryType === 0">
                需要在买家支付后3-15天内完成发货。
              </template>
              <template v-else>
                设置预售周期，预售周期结束后开始计算发货时间。
              </template>
            </p>
          </el-form-item>
        </el-row>
        <el-row v-if="formData.fullPaymentPresaleDeliveryType === 1">
          <el-form-item label="预售周期" prop="presaleTime">
            <el-date-picker
              v-model="formData.presaleTime"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd"
              style="width: 300px !important;"
            />
            <p class="tips-wrap">
                预售周期不超过15天，预售周期结束后将下架商品。
            </p>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发货时效" prop="fullPaymentPresaleDeliveryTime">
            <div class="input-wrap">
              <span class="pre-text">
                <template v-if="formData.fullPaymentPresaleDeliveryType === 0">
                  买家付款后
                </template>
                <template v-else>
                  预售结束后
                </template>
              </span>
              <el-input-digit
                v-model.number="formData.fullPaymentPresaleDeliveryTime"
                :precision="0"
                :maxlength="2"
                style="width: 100px !important;"
                size="mini"
              />
              <span class="pre-text">天内发货</span>
            </div>
            <p class="tips-wrap">
              <template v-if="formData.fullPaymentPresaleDeliveryType === 0">
                可输入3-15天内的整数
              </template>
              <template v-else>
                可输入1-3天内的整数
              </template>
            </p>
          </el-form-item>
        </el-row>
      </template>
    </el-form>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="hanldeSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs'
const defaultFormData = {
  stockType: 0,
  fullPaymentPresaleDeliveryType: null,
  fullPaymentPresaleDeliveryTime: null,
  presaleTime: [],
};
export default {
  name: 'DialogSelectStockType',
  data() {
    const _this = this;
    const validPresaleTime = (rule, value, callback) => {
      if (!value || value.length !== 2) {
        return callback(new Error('请选择预售周期'));
      }
      const beginTime = dayjs(value[0]);
      const endTime = dayjs(value[1]);
      const dayDiff = endTime.diff(beginTime, 'day', true);
      if (dayDiff > 15) {
        return callback(new Error('预售周期不能超过15天'));
      }
      return callback();
    }
    const validDeliverTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写发货时效'));
      }
      const { fullPaymentPresaleDeliveryType } = _this.formData;
      let min = 1, max = 3;
      if (fullPaymentPresaleDeliveryType === 0) {
        min = 3;
        max = 15;
      }
      if (value < min || value > max) {
        return callback(new Error(`只能输入${min}-${max}内的整数`));
      }
      return callback();
    }
    return {
      dialogVisible: false,
      formData: cloneDeep(defaultFormData),
      formRules: {
        stockType: [{ required: true, message: '请选择库存情况' }],
        fullPaymentPresaleDeliveryType: [{ required: true, message: '请选择发货节点' }],
        presaleTime: [{ required: true, message: '请选择预售周期' }, { validator: validPresaleTime }],
        fullPaymentPresaleDeliveryTime: [{ required: true, message: '请填写发货时效' }, { validator: validDeliverTime}]
      }
    };
  },
  methods: {
    handleShow(data) {
      Object.assign(this.formData, data);
      this.dialogVisible = true;
    },
    handleStockTypeChanged(value) {
      this.formData.fullPaymentPresaleDeliveryType = 0;
    },
    handleDeliveryTypeChanged() {
      this.formData.fullPaymentPresaleDeliveryTime = null;
      this.formData.presaleTime = [];
    },
    handleClose() {
      this.dialogVisible = false;
      this.formData = cloneDeep(defaultFormData);
    },
    hanldeSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        const formData = cloneDeep(this.formData);
        const { stockType } = formData;
        const { fullPaymentPresaleDeliveryType, presaleTime } = formData;
        if (fullPaymentPresaleDeliveryType === 1) {
          formData['presaleBeginTime'] = presaleTime[0];
          formData['presaleEndTime'] = presaleTime[1];
        } else {
          formData['presaleBeginTime'] = '';
          formData['presaleEndTime'] = '';
        }
        delete formData['presaleTime'];
        // delete formData['stockType'];
        let deliverInfo = '';
        if (stockType === 1) {
          deliverInfo = JSON.stringify(formData);
        }
        this.$emit('on-success', deliverInfo);
        this.handleClose();
      })
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__label{
  vertical-align: top;
}
.tips-wrap{
  font-size: 12px;
  margin: 0;
  color: #ccc;
}
.sub-title{
    font-size: 12px;
    height: 12px;
    line-height: 12px;
    margin-bottom: 15px;
  }
.input-wrap{
  margin-top: -1px;
  ::v-deep .el-input{
    margin: 0 4px;
  }
  .pre-text{
    color: #606266;
    font-size: 12px;
  }
}
</style>